import { render, staticRenderFns } from "./DigicoopDragonpaySuccessPageView.vue?vue&type=template&id=50b2ddc1&"
import script from "./DigicoopDragonpaySuccessPageView.vue?vue&type=script&lang=js&"
export * from "./DigicoopDragonpaySuccessPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports